export default __webpack_public_path__ + "static/media/tablet.240e4f65.svg";